module.exports = __webpack_public_path__ + "static/home_hero-e1e91d4c43a42bfee306d6db41946657.jpg";